import { Dialog } from "@base-ui/react/dialog";
import styles from "./TimeoutDialog.module.css";

interface MentorTimeoutDialogProps {
  open: boolean;
  postSurveyTimeInMinutes: number;
  onSnooze: () => void;
  onGoToRecommendations: () => void;
}

const MentorTimeoutDialog = ({
  open,
  postSurveyTimeInMinutes,
  onSnooze,
  onGoToRecommendations,
}: MentorTimeoutDialogProps) => {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen && open) {
      onSnooze();
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Backdrop className={styles.backdrop} />

        <Dialog.Viewport className={styles.viewport}>
          <Dialog.Popup className={styles.popup} data-cy="timeout-dialog">
            <Dialog.Title
              className={styles.title}
              data-cy="timout-dialog-title"
            >
              Time's Up!
            </Dialog.Title>

            <Dialog.Description className={styles.description}>
              You've now spent {postSurveyTimeInMinutes} minute
              {postSurveyTimeInMinutes > 1 ? "s" : ""} talking with mentors.
              Would you like to move on to our recommendations page?
            </Dialog.Description>

            <div className={styles.actions}>
              <button
                type="button"
                className={styles.secondaryButton}
                onClick={onSnooze}
                data-cy="snooze-button"
              >
                Snooze for 5 Minutes
              </button>

              <button
                type="button"
                className={styles.primaryButton}
                onClick={onGoToRecommendations}
                data-cy="go-to-recommendations-button"
              >
                Go to Recommendations
              </button>
            </div>
          </Dialog.Popup>
        </Dialog.Viewport>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default MentorTimeoutDialog;
